import { useEffect } from 'react';

type SEOProps = {
  title: string;
  description: string;
  canonicalUrl: string;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  ogImage: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
  schema: Record<string, unknown>;
};

function setMetaByName(name: string, content: string) {
  let element = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function setMetaByProperty(property: string, content: string) {
  let element = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('property', property);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function setCanonical(href: string) {
  let element = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
}

function setSchema(schema: Record<string, unknown>) {
  const id = 'page-schema';
  let element = document.getElementById(id) as HTMLScriptElement | null;
  if (!element) {
    element = document.createElement('script');
    element.id = id;
    element.type = 'application/ld+json';
    document.head.appendChild(element);
  }
  element.text = JSON.stringify(schema);
}

export default function SEO({
  title,
  description,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogUrl,
  ogImage,
  twitterTitle,
  twitterDescription,
  twitterImage,
  schema,
}: SEOProps) {
  useEffect(() => {
    document.title = title;
    setMetaByName('description', description);
    setCanonical(canonicalUrl);
    setMetaByProperty('og:type', 'website');
    setMetaByProperty('og:title', ogTitle);
    setMetaByProperty('og:description', ogDescription);
    setMetaByProperty('og:url', ogUrl);
    setMetaByProperty('og:image', ogImage);
    setMetaByName('twitter:card', 'summary_large_image');
    setMetaByName('twitter:title', twitterTitle || title);
    setMetaByName('twitter:description', twitterDescription || description);
    setMetaByName('twitter:image', twitterImage || ogImage);
    setSchema(schema);
  }, [canonicalUrl, description, ogDescription, ogImage, ogTitle, ogUrl, schema, title, twitterDescription, twitterImage, twitterTitle]);

  return null;
}
